import {
  REQUEST_STRAT,
  RECEIVE_STRAT,
  STRAT_FAILED,
  REQUEST_SP,
  RECEIVE_SP,
  SP_FAILED
} from '../actions/types';

export const strategyRequest = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_STRAT:
      return Object.assign({}, state, {
        isFetching: false,
        strategies: action.strategies
      });
    case REQUEST_STRAT:
      return Object.assign({}, state, {
        isFetching: true,
        strategies: []
      });
    case STRAT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        strategies: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
};

export const salesProductsRequest = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_SP:
      return Object.assign({}, state, {
        isFetching: false,
        salesProducts: action.salesProducts
      });
    case REQUEST_SP:
      return Object.assign({}, state, {
        isFetching: true,
        salesProducts: []
      });
    case SP_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        salesProducts: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
};
